const State = require('../helpers.js').State;

module.exports = State({
    isVisible: false,
    isExpanded: false,
    mode: null,
    disclaimer: State({
        subject: '',
        text: ''
    }),
    conditions: State({
        subject: '',
        text: '',
        read: false
    }),
    isAdult: false,
    readDisclaimer: false,
    readProductDetails: false,
    readConditions: false,
    acceptPersonalData: false
});